import { Injectable } from '@angular/core';
import { Caretaker } from '@/common/undo-redo/caretaker';
import { Originator } from '@/common/undo-redo/originator';
import { deepClone } from '@/_utils/deep-clone';

/*
constant that determines whether the entire data
state or only differences resulting from the action
is saved to the undo/redo functionality
*/
export const USE_UNDO_REDO_DIFF = false;

@Injectable({
	providedIn: 'root',
})
export class NewUndoRedoService<T = unknown> {
	private readonly originator: Originator<T>;
	private readonly caretaker: Caretaker<T>;

	constructor() {
		this.originator = new Originator<T>();
		this.caretaker = new Caretaker<T>(this.originator);
	}

	getState(): T {
		return this.originator.getState();
	}

	setState(state: T): void {
		this.originator.setState(deepClone(state));
		this.caretaker.save();
	}

	undo(): void {
		this.caretaker.undo();
	}

	redo(): void {
		this.caretaker.redo();
	}
}
